// The few rules the blocklist and notes pieces need on pages that load eagerly (Calls, Contacts and the
// phone dock), where the lazily loaded blocklist.css isn't present yet. React 19 hoists this <style>
// into <head> once, however many components render it. Tokens only, like every stylesheet here. React
// may place it before app.css, so a rule that refines a shared class names both classes and wins on
// specificity, not on order.
const CSS = `
.bl-ledger-item { position: relative; }
.bl-ledger-item > .row .row-line2 { padding-right: calc(var(--control-h-small) + var(--space-2)); }
.btn.bl-ledger-action { position: absolute; right: var(--space-3); bottom: var(--space-2); width: var(--control-h-small); min-width: var(--control-h-small); min-height: var(--control-h-small); padding: 0; color: var(--ink-2); }
.btn.bl-ledger-action:hover { color: var(--ink); }
.row-badge.bl-reason-badge { max-width: 100%; min-width: 0; }
.bl-reason-badge > span { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
@media (hover: hover) and (pointer: fine) {
  .bl-ledger-item:not(:hover):not(:focus-within) .btn.bl-ledger-action { opacity: 0; }
}
.check.bl-check { align-items: flex-start; }
.check.bl-check input { margin-top: 3px; flex: none; }
.bl-check-text { display: grid; gap: 2px; }
.bl-blocked { display: grid; grid-template-columns: auto minmax(0, 1fr); gap: var(--space-1) var(--space-2); align-items: start; }
.notice.bl-blocked { border-left-color: var(--end); background: var(--end-tint); }
.bl-blocked > svg { color: var(--end); margin-top: 2px; }
.bl-blocked-body { display: grid; gap: var(--space-1); min-width: 0; }
.bl-actions { display: flex; flex-wrap: wrap; gap: var(--space-2); align-items: center; }
.bl-phone-status { display: flex; flex-wrap: wrap; gap: var(--space-2); align-items: center; margin-top: var(--space-1); }
.bl-phone-actions { display: flex; flex-wrap: wrap; gap: var(--space-2); justify-content: flex-end; }
.note-list { display: grid; gap: 0; border-top: 1px solid var(--rule); }
.note-item { display: grid; gap: var(--space-1); padding: var(--space-3) 0; border-bottom: 1px solid var(--rule); }
.note-item:target, .note-item:focus { background: var(--brass-tint); outline-offset: 2px; }
.note-body { white-space: pre-wrap; overflow-wrap: anywhere; max-width: 72ch; font-size: var(--text-read); line-height: var(--leading-read); }
.note-actions { display: flex; flex-wrap: wrap; gap: var(--space-2); align-items: center; }
.note-confirm { display: grid; gap: var(--space-2); padding: var(--space-3); border-left: 3px solid var(--end); background: var(--end-tint); border-radius: var(--radius-control); }
.call-note { display: grid; gap: var(--space-2); padding-top: var(--space-3); border-top: 1px solid var(--rule-strong); }
.call-note .field textarea { width: 100%; min-height: 72px; resize: vertical; }
.call-note-foot { display: flex; flex-wrap: wrap; gap: var(--space-2); align-items: center; justify-content: space-between; }
.tl-note-quote { display: block; margin-top: var(--space-1); color: var(--ink-2); white-space: pre-wrap; overflow-wrap: anywhere; }
@media (forced-colors: active) {
  .btn.bl-ledger-action { border: 1px solid ButtonText; }
  .note-confirm { border: 1px solid CanvasText; }
}
`;

export function BlocklistInlineStyles() {
  return <style href="sidetone-blocklist-inline" precedence="default">{CSS}</style>;
}
